export default angular.module("mars.vet.dnareports.services.weightlist",[]).factory('WeightListService', function(reportdata) {

    var resultString = reportdata.resultString;
    var sampleDetails = reportdata.sampleDetails;

    return {
        getWeightList: function($scope) {
            var petDetails = sampleDetails.petDetails;

            var weightList = [];
            var displayMsg;
            var weightArray = [];
            var messageArray = [];
            var testName = sampleDetails.testName;
            var resultSize = resultString.resultSize;

            if (petDetails.gender == 'M') {
                if (sampleDetails.petDetails.neuter == 'Y') {
                    displayMsg = "male/neutered";
                    weightArray.push("neutered");
                    messageArray.push(displayMsg);
                } else if (sampleDetails.petDetails.neuter == 'N') {
                    displayMsg = "male/intact";
                    weightArray.push("male");
                    messageArray.push(displayMsg);
                } else {
                    displayMsg = "if male/neutered";
                    weightArray.push("neutered");
                    messageArray.push("Male/Neutered");
                    weightArray.push("male");
                    messageArray.push("Male/Intact");
                }
            } else if (petDetails.gender == 'F') {
                if (sampleDetails.petDetails.neuter == 'Y') {
                    displayMsg = "female/spayed";
                    weightArray.push("spayed");
                    messageArray.push(displayMsg);
                } else if (sampleDetails.petDetails.neuter == 'N') {
                    displayMsg = "female/intact";
                    weightArray.push("female");
                    messageArray.push(displayMsg);
                } else {
                    displayMsg = "if female/spayed";
                    weightArray.push("spayed");
                    messageArray.push("Female/Spayed");
                    weightArray.push("female");
                    messageArray.push("Female/Intact");
                }
            } else {
                displayMsg = "if male/neutred/female/spayed";
                weightArray.push("male");
                weightArray.push("neutered");
                weightArray.push("female");
                weightArray.push("spayed");
            }

            var predSize = 0;
            var minSize = 0;
            var maxSize = 0;

            for (var k = 0; k <= weightArray.length; k++) {
                angular.forEach(resultSize, function(value, key) {
                    predSize = value['pred_size'];
                    minSize = value['min_size'];
                    maxSize = value['max_size'];

                    if (value['type_size'] == weightArray[k]) {
                        if (testName == 'WisdomUK_IN') {
                            predSize = Math.round(predSize * 0.45359237); // convert to kg
                            minSize = Math.round(minSize * 0.45359237);
                            maxSize = Math.round(maxSize * 0.45359237);
                        }
                        weightList.push({
                            "Message": displayMsg,
                            "Type": value['type_size'],
                            "PredSize": predSize,
                            "MinSize": minSize,
                            "MaxSize": maxSize
                        });
                    }
                });
            }
            return weightList;
        }
    };
}).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/services/weightlist.service.js